// src/components/chat/ChatToast.jsx - БЕЗ ИЗМЕНЕНИЙ
import React, { useEffect, useState, useRef } from 'react';
import { Toast, ToastContainer, Badge } from 'react-bootstrap';
import { useChat } from '../../contexts/ChatContext';
import { useNavigate } from 'react-router-dom';

export const ChatToast = () => {
  const [toasts, setToasts] = useState([]);
  const navigate = useNavigate();
  const previousCountsRef = useRef({});
  
  // Безопасно получаем контекст чата
  let chatContext;
  try {
    chatContext = useChat();
  } catch (error) {
    // Контекст еще не доступен - просто не рендерим компонент
    console.log('ChatToast: ChatContext not ready yet');
    return null;
  }
  
  // Если контекст не содержит нужных данных, не рендерим
  if (!chatContext || !chatContext.rooms) {
    return null;
  }
  
  const { rooms, unreadCounts, selectRoom } = chatContext;

  // Следим за появлением новых непрочитанных сообщений
  useEffect(() => {
    // Если комнаты еще не загружены, ничего не делаем
    if (!rooms || rooms.length === 0) return;

    // Функция для показа toast уведомления
    const showToast = (roomId, newMessagesCount) => {
      const room = rooms.find(r => r.id === parseInt(roomId));
      if (!room) return;

      // Получаем имя комнаты
      let roomName = '';
      if (room.type === 'group') {
        roomName = room.name || 'Группа';
      } else if (room.type === 'task') {
        roomName = `Задача #${room.task_id}`;
      } else {
        // Личная переписка - имя другого участника
        const otherParticipant = room.participants?.find(p => p.user_id !== room.created_by);
        roomName = otherParticipant?.user_name || 'Диалог';
      }

      const message = room.last_message?.content || 'Новое сообщение';
      const preview = message.length > 50 ? message.substring(0, 50) + '...' : message;

      const newToast = {
        id: Date.now() + Math.random(),
        roomId: parseInt(roomId),
        roomName,
        preview,
        count: newMessagesCount,
        timestamp: Date.now()
      };

      setToasts(prev => {
        // Оставляем только последние 5 тостов
        const updated = [newToast, ...prev].slice(0, 5);
        return updated;
      });
    };

    // Проверяем изменения в счетчиках непрочитанных
    Object.keys(unreadCounts).forEach(roomId => {
      const currentCount = unreadCounts[roomId];
      const previousCount = previousCountsRef.current[roomId] || 0;
      
      if (currentCount > previousCount) {
        const newMessages = currentCount - previousCount;
        showToast(roomId, newMessages);
      }
      
      // Обновляем предыдущее значение
      previousCountsRef.current[roomId] = currentCount;
    });

  }, [unreadCounts, rooms]);

  const handleToastClick = (toast) => {
    const room = rooms.find(r => r.id === toast.roomId);
    if (room) {
      selectRoom(room);
      navigate('/_admin/chat');
      removeToast(toast.id);
    }
  };

  const removeToast = (toastId) => {
    setToasts(prev => prev.filter(t => t.id !== toastId));
  };

  const formatTime = (timestamp) => {
    const diff = Date.now() - timestamp;
    const mins = Math.floor(diff / 60000);
    if (mins < 1) return 'только что';
    if (mins < 60) return `${mins} мин назад`;
    return 'недавно';
  };

  // Если нет тостов, ничего не рендерим
  if (toasts.length === 0) return null;

  return (
    <ToastContainer 
      position="top-end"
      className="p-3"
      style={{ zIndex: 1070 }}
    >
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          className="notification-toast mb-3 shadow-lg border-0"
          onClose={() => removeToast(toast.id)}
          onClick={() => handleToastClick(toast)}
          delay={8000}
          autohide
          style={{ 
            cursor: 'pointer',
            borderRadius: '12px',
            overflow: 'hidden',
            minWidth: '320px',
            backdropFilter: 'blur(10px)'
          }}
        >
          <Toast.Header 
            className="bg-primary text-white"
            style={{ 
              borderBottom: '1px solid rgba(255,255,255,0.2)',
              padding: '12px 16px'
            }}
          >
            <i className="bi bi-chat-fill me-2"></i>
            <strong className="me-auto" style={{ fontSize: '0.95rem' }}>
              Новое сообщение
            </strong>
            <small className="opacity-80">{formatTime(toast.timestamp)}</small>
          </Toast.Header>
          <Toast.Body 
            className="bg-light"
            style={{ 
              padding: '16px',
              fontSize: '0.9rem',
              lineHeight: '1.4'
            }}
          >
            <div className="d-flex align-items-start">
              <div className="flex-grow-1">
                <strong>{toast.roomName}</strong>
                <div className="mt-1 text-muted">
                  {toast.preview}
                </div>
                {toast.count > 1 && (
                  <Badge bg="danger" className="mt-2">
                    +{toast.count} новых сообщений
                  </Badge>
                )}
              </div>
            </div>
            <div className="mt-2 text-muted small">
              Нажмите, чтобы открыть чат
            </div>
          </Toast.Body>
        </Toast>
      ))}
    </ToastContainer>
  );
};